var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entertheshop"},[_c('van-cell',{attrs:{"icon":_vm.datas.icon,"title":_vm.datas.shopName,"is-link":"","value":_vm.datas.copywriting,"to":_vm.datas.type == 10 ? _vm.datas.http.externalLink : '',"url":_vm.datas.type == 11 ? _vm.datas.http.externalLink : ''}}),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }